import { type CommandHandler } from '@telespot/core';

import { CreateInvitation } from './create-invitation.command';
import { type InvitationRepository, Invite, type RoleRepository } from '@telespot/domain';

export type ICreateInvitationHandler = CommandHandler<CreateInvitation>;

export class CreateInvitationHandler implements ICreateInvitationHandler {
  constructor(private readonly invitations: InvitationRepository, private readonly roles: RoleRepository) {}

  public async execute(command: CreateInvitation): Promise<string> {
    const { organizationId, code, uses, initialWorkspaces, initialRoles } = command.details;
    const roles = await this.roles.list();
    const includedRoles = roles.filter((r) => initialRoles.includes(r.id));

    const invitation = new Invite({
      code: code,
      uses: uses,
      initialWorkspaces: initialWorkspaces,
      initialRoles: includedRoles,
      organizationId: organizationId,
    });

    return this.invitations.save(invitation);
  }
}
